<template>
  <div>
    <v-btn
      class="ma-2"
      outlined
      color="primary"
      :disabled="disabledBtn"
      block
      @click="processData(0)"
    >
      Estadísticas de Grupo
    </v-btn>
    <v-row justify="center">
      <v-dialog
        v-show="detailsGroup.name"
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title
              >Estadísticas - {{ detailsGroup.name }}</v-toolbar-title
            >
            <v-spacer />
            <v-toolbar-items />
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12" sm="8">
                <v-subheader>Estadísticas por nivel</v-subheader>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="report_option"
                  :items="evaluations"
                  item-text="name"
                  item-value="value"
                  label="Seleccione evaluación"
                />
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col v-for="(n, i) in 8" :key="i" cols="3" sm="2" md="1">
                <level-statistics
                  :number-level="i"
                  :students-group="studentsGroup"
                />
              </v-col>
              
            </v-row>

            
            
          </v-container>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-list three-line subheader>
                  <v-subheader
                    >Estadísticas del Episodio (todos los niveles)</v-subheader
                  >
                  <v-list-item>
                    <v-list-item-content>
                      <span>Total de alumnos: {{ countStudent }}</span>
                      <span
                        >Promedio de avance del juego:
                        {{
                          parseFloat(
                            (avgProgress / countStudent) * 100
                          ).toFixed(2)
                        }}
                        %</span
                      >
                      <!-- <span
                        >Total promedio de respuestas correctas:
                        {{
                          parseFloat(avgCorrectAnswers / countStudent).toFixed(
                            2
                          )
                        }}</span
                      >
                      <span
                        >Total promedio del tiempo respuesta por multiplicación
                        (hh:mm:ss):
                        {{
                          formatSeconds(
                            avgTimeAnswersMultiplication / countStudent
                          )
                        }}</span
                      >
                      <span
                        >Total promedio del tiempo de lectura por cuadro de
                        texto (hh:mm:ss):
                        {{
                          formatSeconds(avgTimeReadTextBox / countStudent)
                        }}</span
                      > -->
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" md="6">
                <base-material-card
                  icon="mdi-account-details-outline"
                  title="Avance de los que ya iniciaron"
                  class="px-5 py-3"
                >
                  <v-data-table
                    :headers="headersTable1"
                    :items="dataTable1"
                    item-key="category"
                    class="elevation-1"
                    :hide-default-footer="true"
                  >
                    <template v-slot:[`item.lists`]="{ item }">
                      <v-menu offset-y :rounded="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            outlined
                            small
                            :disabled="[`item.lists`] < 1"
                            v-on="on"
                          >
                            Estudiantes
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(student, index) in item.lists"
                            :key="index"
                          >
                            <v-list-item-title>{{ student }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </base-material-card>
              </v-col>

              
            </v-row>

            <help-button
                :tutorial="tutorial"
              />
            
          </v-container>

          <v-divider />

          <!-- PROMEDIOS POR EPISODIO
            <v-container>
            <v-row>
              <v-col cols="12" class="mt-6">
                <base-material-card
                  icon="mdi-playlist-check"
                  title="Respuestas correctas por nivel"
                  class="px-5 py-3"
                >
                  <v-data-table
                    :headers="headersTable2"
                    :items="dataTable2"
                    :hide-default-footer="true"
                  >
                  <template v-slot:[`item.lists`]="{ item }">
                      <v-menu offset-y :rounded="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            outlined
                            small
                            :disabled="[`item.lists`] < 1"
                            v-on="on"
                          >
                            Estudiantes
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(student, index) in item.lists"
                            :key="index"
                          >
                            <v-list-item-title>{{ student }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </base-material-card>
              </v-col>
              <v-col cols="12" class="mt-6">
                <base-material-card
                  icon="mdi-timeline-clock-outline"
                  title="Tiempo promedio de respuesta por multiplicación"
                  class="px-5 py-3"
                >
                  <v-data-table
                    :headers="headersTable3"
                    :items="dataTable3"
                    :hide-default-footer="true"
                  >
                  <template v-slot:[`item.lists`]="{ item }">
                      <v-menu offset-y :rounded="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            outlined
                            small
                            :disabled="[`item.lists`] < 1"
                            v-on="on"
                          >
                            Estudiantes
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(student, index) in item.lists"
                            :key="index"
                          >
                            <v-list-item-title>{{ student }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </base-material-card>
              </v-col>
              <v-col cols="12" class="mt-6">
                <base-material-card
                  icon="mdi-timetable"
                  title="Tiempo promedio de lectura por cuadro de texto"
                  class="px-5 py-3"
                >
                  <v-data-table
                    :headers="headersTable4"
                    :items="dataTable4"
                    :hide-default-footer="true"
                  >
                  <template v-slot:[`item.lists`]="{ item }">
                      <v-menu offset-y :rounded="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            outlined
                            small
                            :disabled="[`item.lists`] < 1"
                            v-on="on"
                          >
                            Estudiantes
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(student, index) in item.lists"
                            :key="index"
                          >
                            <v-list-item-title>{{ student }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </base-material-card>
              </v-col>
            </v-row>
          </v-container> -->

        

        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
  import HelpButton from '@/views/dashboard/pages/panel/HelpButton'

import LevelStatistics from "@/views/dashboard/pages/panel/LevelStatistics";
export default {
  components: {
    LevelStatistics,
      HelpButton,

  },
  props: {
    disabledBtn: {
      type: Boolean,
      default: true,
    },
    detailsGroup: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tutorial: 'tutorial-group-statistics',
      report_option: 0,
      evaluations: [
        { name: "Evaluación #1", value: 0 },
        { name: "Evaluación #2", value: 1 },
      ],
      dialog: false,
      studentsGroup: [],
      group: [],
      timeAnswers: [],
      timeReads: [],
      threshold: 0,
      avgProgress: 0,
      avgCorrectAnswers: 0,
      avgTimeAnswersMultiplication: 0,
      fastTimeAnswersMultiplication: 0,
      slowTimeAnswersMultiplication: 0,
      avgTimeReadTextBox: 0,
      fastTimeReadTextBox: 0,
      slowTimeReadTextBox: 0,
      headersTable1: [
        {
          text: "",
          align: "start",
          value: "category",
          sortable: false,
        },
        {
          text: "Cantd. de Alumnos",
          value: "count",
          align: "center",
          sortable: false,
        },
        {
          text: "Lista de Alumnos",
          value: "lists",
          align: "center",
          sortable: false,
        },
      ],
      dataTable1: [
        {
          category: "Mayor a 75% hasta 100% (hasta 8vo nivel)",
          count: 0,
          lists: [],
        },
        {
          category: "Mayor a 50% hasta 75% (hasta 6to nivel)",
          count: 0,
          lists: [],
        },
        {
          category: "Mayor a 25% hasta 50% (hasta 4to nivel)",
          count: 0,
          lists: [],
        },
        {
          category: "Menor a 25% (hasta 2do nivel)",
          count: 0,
          lists: [],
        },
      ],
      headersTable2: [
        {
          text: "",
          align: "start",
          value: "category",
          sortable: false,
        },
        {
          text: "Cantd. de Alumnos",
          value: "count",
          align: "center",
          sortable: false,
        },
        {
          text: "Promedio respuestas correctas",
          value: "avg",
          align: "center",
          sortable: false,
        },
         {
          text: "Lista de Alumnos",
          value: "lists",
          align: "center",
          sortable: false,
        },
      ],
      dataTable2: [
        {
          category: "20 - 18 respuestas correctas",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "17 - 12 respuestas correctas",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "11 - 0 respuestas correctas",
          count: 0,
          avg: 0,
          lists: [],
        },
      ],
      headersTable3: [
        {
          text: "Subgrupo",
          align: "start",
          value: "category",
          sortable: false,
        },
        {
          text: "Cantd. de Alumnos",
          value: "count",
          align: "center",
          sortable: false,
        },
        {
          text: "Promedio de tiempo (seg.)",
          value: "avg",
          align: "center",
          sortable: false,
        },
         {
          text: "Lista de Alumnos",
          value: "lists",
          align: "center",
          sortable: false,
        },
      ],
      dataTable3: [
        {
          category: "20% de alumnos con menores tiempos",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "Grupo medio",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "20% de alumnos con mayores tiempos",
          count: 0,
          avg: 0,
          lists: [],
        },
      ],
      headersTable4: [
        {
          text: "Subgrupo",
          align: "start",
          value: "category",
          sortable: false,
        },
        {
          text: "Cantd. de Alumnos",
          value: "count",
          align: "center",
          sortable: false,
        },
        {
          text: "Promedio de tiempo (seg.)",
          value: "avg",
          align: "center",
          sortable: false,
        },
        {
          text: "Lista de Alumnos",
          value: "lists",
          align: "center",
          sortable: false,
        },
      ],
      dataTable4: [
        {
          category: "20% de alumnos con menores tiempos",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "Grupo medio",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "20% de alumnos con mayores tiempos",
          count: 0,
          avg: 0,
          lists: [],
        },
      ],
    };
  },
  computed: {
    ...mapState(["userData"]),
    students() {
      return this.detailsGroup.students;
    },
    countStudent() {
      return this.detailsGroup.students.length;
    },
  },
  watch: {
    detailsGroup(val) {
      this.init();
    },
    report_option(value) {
      this.processData(value);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    formatSeconds(seconds) {
      return moment().hours(0).minutes(0).seconds(seconds).format("HH:mm:ss");
    },
    formatValue(val) {
      return val.fixed(2);
    },
    selectReport(r) {
      console.log(r);
    },
    init() {

      this.studentsGroup = [];

      let allStudents = this.userData.students.concat(this.userData.studentsAssigned);
      allStudents.map((st) => 
      {
        if (this.students.includes(st.actions.id)) {
          this.studentsGroup.push(st);
        }
      });

      console.log("group["+this.detailsGroup.name+"] students: "+this.studentsGroup.length);

    },
    processData(ev) {
      this.$store.commit("SET_LOADING", true);
      this.dataTable1.map((t) => {
        t.count = 0;
        t.lists = [];
      });
      this.dataTable2.map((t) => {
        t.count = 0;
        t.avg = 0;
        t.lists = [];
      });
      this.dataTable3.map((t) => {
        t.count = 0;
        t.avg = 0;
        t.lists = [];
      });
      this.dataTable4.map((t) => {
        t.count = 0;
        t.avg = 0;
        t.lists = [];
      });
      this.avgProgress = 0;
      this.avgCorrectAnswers = 0;
      this.avgTimeAnswersMultiplication = 0;
      this.avgTimeReadTextBox = 0;

      this.threshold = Math.ceil(this.studentsGroup.length * 0.2);

      this.timeAnswers = [];
      this.timeReads = [];

      this.studentsGroup.forEach((student) => {
        if (student.episode1?.TotalLevelsEvaluations[ev]) {
          const completed = student.episode1?.TotalLevelsEvaluations[ev]
            ? student.episode1?.TotalLevelsEvaluations[ev] / 8
            : 0;
          this.avgProgress += parseFloat(completed);

          const correct = student.episode1.AvgCorrectEvaluations[ev]
            ? student.episode1.AvgCorrectEvaluations[ev]
            : 0;
          this.avgCorrectAnswers += parseFloat(correct);

          const timeAnswersMultiplication = student.episode1
            .AvgSolveTimeEvaluations[ev]
            ? student.episode1.AvgSolveTimeEvaluations[ev]
            : 0;
          this.avgTimeAnswersMultiplication += parseFloat(
            timeAnswersMultiplication
          );

          this.timeAnswers.push(timeAnswersMultiplication);

          const avgTimeReadTextBox = student.episode1.AvgStoryTimeEvaluations[
            ev
          ]
            ? student.episode1.AvgStoryTimeEvaluations[ev]
            : 0;
          this.avgTimeReadTextBox += parseFloat(avgTimeReadTextBox);

          this.timeReads.push(avgTimeReadTextBox);

          // const completed = student.episode1.levelsCompleted ? student.episode1.levelsCompleted : 0
          // this.avgProgress += completed
          // this.avgProgress /= this.countStudent

          // const correct = student.episode1.levelsTotalCorrect ? student.episode1.levelsTotalCorrect : 0
          // this.avgCorrectAnswers += correct
          // this.avgCorrectAnswers /= this.countStudent

          // const timeAnswersMultiplication = student.episode1.levelsSolveTime ? student.episode1.levelsSolveTime : 0;
          // this.avgTimeAnswersMultiplication += timeAnswersMultiplication;
          // this.avgTimeAnswersMultiplication /= this.countStudent;
          // console.log("Avg Time", this.avgTimeAnswersMultiplication);

          // const avgTimeReadTextBox = student.episode1.levelsStoryTime ? student.episode1.levelsStoryTime : 0
          // this.avgTimeReadTextBox += avgTimeReadTextBox
          // this.avgTimeReadTextBox /= this.countStudent
        }
      });

      this.timeAnswers.sort((a, b) => b - a);
      this.timeReads.sort((a, b) => b - a);

      this.studentsGroup.forEach((student) => {
        if (student.episode1?.TotalLevelsEvaluations[ev]) {
          this.levelsCompleted(student);
          // this.correctAnswers(student);
          // this.levelsSolveTime(student);
          // this.levelsStoryTime(student);
          // this.group.push({
          //   levelsCompleted: student.episode1.levelsCompleted
          //     ? student.episode1.levelsCompleted
          //     : 0,
          //   levelsSolveTime: student.episode1.levelsSolveTime,
          //   levelsStoryTime: student.episode1.levelsStoryTime,
          //   levelsTotalCorrect: student.episode1.levelsTotalCorrect,
          // });
        }
      });

      //this.averageTable(this.dataTable2)

      this.$store.commit("SET_LOADING", false);
      this.dialog = true;
    },
    levelsCompleted(st) {
      const completed = st.episode1?.TotalLevelsEvaluations[this.report_option]
        ? st.episode1?.TotalLevelsEvaluations[this.report_option]
        : 0;
      const student = st.details;
      switch (true) {
        case completed <= 2:
          this.dataTable1[3].count++;
          this.dataTable1[3].lists.push(student.name);
          break;
        case completed <= 4:
          this.dataTable1[2].count++;
          this.dataTable1[2].lists.push(student.name);
          break;
        case completed <= 6:
          this.dataTable1[1].count++;
          this.dataTable1[1].lists.push(student.name);
          break;
        default:
          this.dataTable1[0].count++;
          this.dataTable1[0].lists.push(student.name);
          break;
      }
    },
    averageTable(table) {
      if (table[2].count > 0)
        table[2].avg = (table[2].avg / parseFloat(table[2].count)).toFixed(2);

      if (table[1].count > 0)
        table[1].avg = (table[1].avg / parseFloat(table[1].count)).toFixed(2);

      if (table[0].count > 0) {
        table[0].avg = (table[0].avg / parseFloat(table[0].count)).toFixed(2);
      }
    },
    correctAnswers(st) {
      const correct = st.episode1.AvgCorrectEvaluations[this.report_option]
        ? st.episode1.AvgCorrectEvaluations[this.report_option]
        : 0;
      const student = st.details;
      switch (true) {
        case correct <= 11.5: {
          this.dataTable2[2].count++;
          this.dataTable2[2].avg = parseFloat(correct);
          this.dataTable2[2].lists.push(student.name);
          break;
        }
        case correct <= 17.5: {
          this.dataTable2[1].count++;
          this.dataTable2[1].avg = parseFloat(correct);
          this.dataTable2[1].lists.push(student.name);
          break;
        }
        case correct <= 20: {
          this.dataTable2[0].count++;
          this.dataTable2[0].avg = parseFloat(correct);
          this.dataTable2[0].lists.push(student.name);
          break;
        }
      }
    },
    levelsSolveTime(st) {
      const solveTime = st.episode1.AvgSolveTimeEvaluations[this.report_option]
        ? st.episode1.AvgSolveTimeEvaluations[this.report_option]
        : 0;
      const currentIndex = this.timeAnswers.indexOf(solveTime);
      const student = st.details;

      switch (true) {
        case currentIndex > this.timeAnswers.length - this.threshold - 1: {
          this.dataTable3[0].count++;
          let avgT = parseFloat(this.dataTable3[0].avg);
          avgT += parseFloat(solveTime);
          avgT /= this.dataTable3[0].count;
          this.dataTable3[0].avg = parseFloat(avgT).toFixed(2);
          this.dataTable3[0].lists.push(student.name);
          break;
        }
        case currentIndex < this.threshold: {
          this.dataTable3[2].count++;
          let avgT = parseFloat(this.dataTable3[2].avg);
          avgT += parseFloat(solveTime);
          avgT /= this.dataTable3[2].count;
          this.dataTable3[2].avg = parseFloat(avgT).toFixed(2);
          this.dataTable3[2].lists.push(student.name);
          break;
        }
        default: {
          this.dataTable3[1].count++;
          let avgT = parseFloat(this.dataTable3[1].avg);
          avgT += parseFloat(solveTime);
          avgT /= this.dataTable3[1].count;
          this.dataTable3[1].avg = parseFloat(avgT).toFixed(2);
          this.dataTable3[1].lists.push(student.name);
          break;
        }
      }
    },
    levelsStoryTime(st) {
      const storyTime = st.episode1.AvgStoryTimeEvaluations[this.report_option]
        ? st.episode1.AvgStoryTimeEvaluations[this.report_option]
        : 0;
      const currentIndex = this.timeReads.indexOf(storyTime);
      const student = st.details;

      switch (true) {
        case currentIndex > this.timeReads.length - this.threshold - 1: {
          this.dataTable4[0].count++;
          let avgT = parseFloat(this.dataTable4[0].avg);
          avgT += parseFloat(storyTime);
          avgT /= this.dataTable4[0].count;
          this.dataTable4[0].avg = parseFloat(avgT).toFixed(2);
          this.dataTable4[0].lists.push(student.name);         
          break;
        }
        case currentIndex < this.threshold: {
          this.dataTable4[2].count++;
          let avgT = parseFloat(this.dataTable4[2].avg);
          avgT += parseFloat(storyTime);
          avgT /= this.dataTable4[2].count;
          this.dataTable4[2].avg = parseFloat(avgT).toFixed(2);
          this.dataTable4[2].lists.push(student.name);
          break;
        }
        default: {
          this.dataTable4[1].count++;
          let avgT = parseFloat(this.dataTable4[1].avg);
          avgT += parseFloat(storyTime);
          avgT /= this.dataTable4[1].count;
          this.dataTable4[1].avg = parseFloat(avgT).toFixed(2);
          this.dataTable4[1].lists.push(student.name);
          break;
        }
      }
    },
  },
};
</script>
